import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F9FAFB]" data-testid="auth-loading">
        <CircleNotch size={32} className="animate-spin text-[#0055FF]" />
      </div>
    );
  }
  if (user === false) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  // Client logins are scoped to their own dashboard only.
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/home" replace />;
  }
  return children;
}
